import { IProduct, IProductModifier, IProductModifierOption, PRODUCT_TYPE } from 'src/types/products';
import { getProductMainPrice } from './formatter';
import { getFirstCorrectMealSize } from './helpers';

export const calculateProductPrice = (product: IProduct, withoutQuantity?: boolean) => {
  let price = getProductMainPrice(product);

  if (product.type === PRODUCT_TYPE.MEAL_COMBO) {
    price = 0;
    if (!product.sizes.length || !product.items?.length) return price;

    const correctSize = getFirstCorrectMealSize(product);
    let isCart: boolean = false;
    let cartPrice: number = 0;

    product.items.forEach((item) => {
      if (item.size_id === correctSize?.id && item.is_selected) {
        isCart = true;
        cartPrice += Number(item.price);
      }

      if (item.size_id === correctSize?.id && item.is_default && !isCart) price += Number(item.price);
    });

    return (isCart ? cartPrice : price) * (withoutQuantity ? 1 : product.quantity);
  }

  price = product.modifiers.reduce((_price: number, modifier: IProductModifier): number => {
    return modifier.options.reduce((__price: number, option: IProductModifierOption) => {
      if (option.selected) {
        __price = __price + option.price * (option.quantity || 1);
      }
      return __price;
    }, _price);
  }, price);

  price = price * product.quantity;
  return price;
};
